import apiService from '../../services/api';

// Init state
const state = {
    items: []
};

// Actions
const actions = {
    getList: (context, params) => {
        return apiService.get('post.index', params);
    },
    create: (context, params) => {
        return apiService.post('post.index', params);
    },
    update: (context, params) => {
        return apiService.put('post.detail', params);
    },
    delete: (context, params) => {
        return apiService.delete('post.detail', params);
    },
    getInfo: (context, params) => {
        return apiService.get('post.detail', params);
    }
};

// Mutation
const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
